import moment from 'moment'
import { toUTCDay } from './helpers'
// некорректно отрабатывает в WsRequestExamGroupForm
export default function computedDateProp (prop, field) {
  return {
    set (date) {
      this[prop][field] = date
        ? toUTCDay(date).toISOString()
        : null
    },
    get () {
      const date = moment.utc(this[prop][field])
      return date.isValid()
        ? new Date(
          date.toISOString().replace(/-/g, '/').replace(/T.+/, ''))
        : null
    }
  }
}

export function computedDate (prop, field) {
  return {
    set (date) {
      this[prop][field] = date
        ? toUTCDay(date).toISOString()
        : null
    },
    get () {
      const date = moment(this[prop][field])
      return date.isValid()
        ? new Date(this[prop][field])
        : null
    }
  }
}
